import { render, staticRenderFns } from "./ModalBasicTailwind.vue?vue&type=template&id=6cf7110a"
import script from "./ModalBasicTailwind.vue?vue&type=script&lang=js"
export * from "./ModalBasicTailwind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports